// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop, orderBy } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"

/** initla state for auth store  */
const initialState = {
  data: [],
  count: "",
  current: {},
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const directSale = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCount: (s, payload) => {
      return {
        ...s,
        count: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateActivated: (s, payload) => {
      const index = s.data.findIndex((e) => e.id === payload.id)
      const item = s.data[index]
      item.status = payload.status
      const _data = s.data.filter((e) => e.id !== payload.id)
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateItemOldImages: (s, payload) => {
      const index = s.data.findIndex((e) => e.id === payload.id)
      const item = s.data[index]
      item.images = item.images.filter((e) => e !== payload.image)
      const _data = s.data.filter((e) => e.id !== payload.id)
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateSingleItem: (s, payload) => {
      const index = s.data.findIndex((e) => e.id === payload.id)
      const item = payload
      item.data = JSON.stringify(item.data)
      const _data = s.data.filter((e) => e.id !== payload.id)
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.bidding],
        (bidding, biddingsLoading) => {
          return biddingsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.bidding],
        (bidding, biddingLoading) => biddingLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (bidding) => {
        let _data = bidding.data
        if (!isEmpty(bidding.filters)) {
          const status = bidding.filters.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage

          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }
        if (!!bidding.keyword) {
          const options = {
            keys: ["phone", "stats"]
          }
          const fuse = new Fuse(bidding.data, options)
          _data = fuse.search(bidding.keyword)
          _data = _data.map((e) => e.item)
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage
          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }
        return orderBy(_data, (a) => new Date(a.updatedAt), ["desc"])
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchAll() {
      appLogger.info("fetchAll", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.FETCH_DRIECT_SALE)
      try {
        const query = `
        query MyQuery {
          fetchAuctions(type: "SALE",filter:{status: {ne: "SOLD"}}) {
            items {
              id,
               ref,
               category,
               images,
               titleAr,
               descr,
               descrAr,
               status,
               title,
                 bid{
                 auction,
                 biddings
                 },
                 sale{
                  auction,
                  ref,
                  currentPrice,
                  lastPriceTime,
                  total,
                  amount,
                  buyers
                 }
               totalBid,
               type,
               data,
               currentIncr,
               minimumIncr,
               cover,
               createdAt,
               updatedAt,
               expireAt,

                 }
          }
        }
        `
        const { data } = await API.post("auctionGraphql", "", {
          body: {
            query
          }
        })
        const items = data.fetchAuctions.items

        this.setData(items)
        // this.setCount(count)
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     */
    async fetchSolded() {
      appLogger.info("fetchSolded", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.FETCH_DRIECT_SALE)
      try {
        const query = `
        query MyQuery {
          fetchAuctions(type: "SALE",filter:{status: {eq: "SOLD"}}) {
            items {
              id,
               ref,
               category,
               images,
               titleAr,
               descr,
               descrAr,
               status,
               title,
                 bid{
                 auction,
                 biddings
                 },
                 sale{
                  auction,
                  ref,
                  currentPrice,
                  lastPriceTime,
                  total,
                  amount,
                  buyers
                 }
               totalBid,
               type,
               data,
               currentIncr,
               minimumIncr,
               cover,
               createdAt,
               updatedAt,
               expireAt,

                 }
          }
        }
        `
        const { data } = await API.post("auctionGraphql", "", {
          body: {
            query
          }
        })
        const items = data.fetchAuctions.items

        this.setData(items)
        // this.setCount(count)
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} id
     */
    async refreshItem(id) {
      appLogger.info("refreshItem", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.GET_AUCTION)

      try {
        const result = await API.get("auctionsApiGateway", `/auctions/${id}`)

        this.updateSingleItem(result)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async deleteItem({ id, createdAt }) {
      appLogger.info("deleteItem", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.DELETE_ITEM)

      try {
        await API.post("auctionsApiGateway", `/auctions/${id}/rm`, {
          body: { sk: createdAt }
        })
        this.setMessage("msg_item_deleted")
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async cancelItem({ id, createdAt, status, expireAt, category, type }) {
      appLogger.info("cancelItem", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.CANCEL_ITEM)

      try {
        await API.put("auctionsApiGateway", `/auctions/${id}/status`, {
          body: { createdAt, status, expireAt, category, type }
        })
        this.updateActivated({ id, status })
        this.setMessage("msg_item_canceled")
        // this.updateItem({ id, image })
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async deleteImage({ id, createdAt, image, images }) {
      appLogger.info("updateCover", `[REDUX][${STORES.AUCTIONS}]`)
      this.setAction(globalConst.action.DELETE_AUCTION_PHOTO)

      try {
        await API.put("auctionsApiGateway", `/auctions/${id}`, {
          body: { images, createdAt }
        })

        this.updateItemOldImages({ id, image })
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async activateItem({ id, createdAt, status, expireAt, category, type }) {
      appLogger.info("activateItem", `[REDUX][${STORES.DIRECT_SALE}]`)
      this.setAction(globalConst.action.ACTIVATE_ITEM)

      try {
        await API.put("auctionsApiGateway", `/auctions/${id}/status`, {
          body: { createdAt, status, expireAt, category, type }
        })
        this.updateActivated({ id, status })
        this.setMessage("msg_item_activated")
        // this.updateItem({ id, image })
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     */
    async fetchBids() {
      appLogger.info("fetchBids", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.FETCH_BIDS)
      try {
        const { items, count } = await API.get("biddingApiGateway", "/bids")

        this.setData(items)
        this.setCount(count)
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    }
  })
}
